import TesztlapokTableService from 'app/admin/tesztlapok/service/TesztlapokTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'tesztlapokTable',
	text: 'Tesztlapok',
	textKey: 'testsheet',
	service: TesztlapokTableService,
	icon: 'person',
	editFormState: item => `/tesztlapok/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csomagNev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'vizsgazoAzonosito',
			text: 'Azonosító',
			textKey: 'vizsgazoAzonosito',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'oldal',
			text: 'Oldal',
			textKey: 'oldal',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'csomagNev',
			text: 'Csomag neve',
			textKey: 'csomagNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feltoltoTesztlapNev',
			text: 'Feltöltő',
			textKey: 'feltoltoTesztlapNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feltoltesIdeje',
			text: 'Feltöltés ideje',
			textKey: 'feltoltesIdeje',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'vizsgaLeiras',
			text: 'Vizsga',
			textKey: 'vizsgaLeiras',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'modositva',
			text: 'Módosítva',
			textKey: 'modositva',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function TesztlapokTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('tesztlapokTable', reducer('tesztlapokTable'))(TesztlapokTable);
